// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import head from "vue-head";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import i18n from "@/locales";
import Vuelidate from "vuelidate";
import { HTTP } from "@/helpers/http-common";
import VueSweetalert2 from "vue-sweetalert2";
import { validateCheckListAfterRefresh } from "@/helpers/app-refresh-check-list";
import vuetify from "@/plugins/vuetify";
import VueMask from "v-mask";
import FilePond from "@/plugins/filepond";
import VueCookie from "vue-cookie";
import Croppa from "vue-croppa";
import Vuebar from "vuebar";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCoffee } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "@hcaptcha/vanilla-hcaptcha";
import "@fortawesome/fontawesome-free/css/all.css";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@/assets/css/animate.css";
import "vue-croppa/dist/vue-croppa.css";
import "flag-icons/css/flag-icons.min.css";

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.ignoredElements = ["h-captcha"];

// Add plugins
Vue.use(head);
Vue.use(Vuelidate);

Vue.use(VueSweetalert2);
Vue.use(router);

Vue.use(Vuebar);
Vue.use(VueMask);
Vue.use(VueCookie);

Vue.use(Croppa, { componentName: "croppa" });
library.add(faCoffee);

Vue.component("FontAwesomeIcon", FontAwesomeIcon);

/* eslint-disable no-new */
export default new Vue({
  el: "#app"
  , components: {
    App
    , FilePond
  }
  // localStorage
  , beforeCreate() {
    validateCheckListAfterRefresh(this.$store, HTTP, this.$userPermission);
  }
  , router
  , store
  , i18n
  , vuetify
  , template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js